import React from "react";
import getClassNameFactory from "../../utilities/classNames";
import Alignment, { HorizontalAlignments, VerticalAlignments } from "../Alignment";
import Spinner from "./components/Spinner";

var Loading = function Loading(props) {
  var text = props.text,
      iconTitle = props.iconTitle;
  var getClassName = getClassNameFactory(Loading.displayName);
  return /*#__PURE__*/React.createElement("div", {
    "aria-label": text,
    className: getClassName()
  }, /*#__PURE__*/React.createElement(Alignment, {
    horizontal: HorizontalAlignments.CENTER,
    vertical: VerticalAlignments.CENTER
  }, /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "inner"
    })
  }, /*#__PURE__*/React.createElement(Spinner, {
    iconTitle: iconTitle
  })), /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "text"
    })
  }, text)));
};

Loading.displayName = "Loading";
export default Loading;